export const c_popover_MaxWidth = {
  "name": "--pf-v5-c-popover--MaxWidth",
  "value": "none",
  "var": "var(--pf-v5-c-popover--MaxWidth)"
};
export default c_popover_MaxWidth;